import { useMemo } from 'react';

import { useWebContext } from '@/resources/hooks/useWebContext';

export default function PbmIcon({
  color,
  width,
  height,
}: {
  color?: string;
  width?: number;
  height?: number;
}) {
  const { configs } = useWebContext();

  const pbmColor = color ?? useMemo(() => configs.pbm_price_color, [configs]);
  return (
    <svg
      width={width || '15'}
      height={height || '16'}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.71018 9.34352V11.8981C6.71018 12.1886 6.82303 12.4672 7.02517 12.6722L9.98972 15.6796C10.4108 16.1068 11.093 16.1068 11.5141 15.6796L13.7628 13.3984C14.1839 12.9712 14.1839 12.2791 13.7628 11.852L10.7982 8.84457C10.5961 8.63951 10.3215 8.52503 10.0352 8.52503L7.5187 8.52332C7.07233 8.52332 6.71018 8.8907 6.71018 9.34352ZM8.5967 9.89032C8.73966 9.89032 8.87676 9.94791 8.97784 10.0505C9.07893 10.153 9.13571 10.2921 9.13571 10.4372C9.13571 10.5821 9.07893 10.7212 8.97784 10.8237C8.87676 10.9263 8.73966 10.9839 8.5967 10.9839C8.45376 10.9839 8.31666 10.9263 8.21558 10.8237C8.11449 10.7212 8.0577 10.5821 8.0577 10.4372C8.0577 10.2921 8.11449 10.153 8.21558 10.0505C8.31666 9.94791 8.45376 9.89032 8.5967 9.89032Z"
        fill={pbmColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.86808 0C3.34407 0 2.92072 0.417641 2.92072 0.934582C2.92072 1.45153 3.34407 1.86916 3.86808 1.86916V5.74768C3.86808 6.0923 3.77039 6.43402 3.58683 6.72607L0.383547 11.8633C0.185192 12.1846 0.0786133 12.5496 0.0786133 12.9265C0.0786133 14.045 0.999335 14.9533 2.13322 14.9533H8.02317L6.39999 13.3067C6.03058 12.932 5.82596 12.4245 5.82596 11.8981V9.34583H4.17893L5.20031 7.70739C5.56742 7.11743 5.76282 6.43986 5.76282 5.74768V1.86916H7.65755V5.74768C7.65755 6.40846 7.83561 7.05593 8.17115 7.62656L10.0352 7.62783C10.1645 7.62786 10.2928 7.64081 10.4182 7.66604L9.83349 6.72899C9.64998 6.43402 9.55228 6.09523 9.55228 5.7506V1.86916C10.0763 1.86916 10.4997 1.45153 10.4997 0.934582C10.4997 0.417641 10.0763 0 9.55228 0H3.86808Z"
        fill={pbmColor}
      />
    </svg>
  );
}
